import { AuditLogEntity } from "domain/entity/AuditLog/AuditLogEntity";
import { INITIAL_CHARGE_AUDIT_LOG_COL_DEF, INITIAL_COLLECTION_AUDIT_LOG_COL_DEF, INITIAL_COMPANY_AUDIT_LOG_COL_DEF, INITIAL_WAIVER_AUDIT_LOG_COL_DEF, transferRowData } from "presentation/constant/AuditLog/AuditLogMaintenanceColumnDefinition";
import { useAuditLogMaintenanceVM } from "presentation/hook/AuditLog/useAuditLogMaintenanceVM";
import { useAuditLogMaintenanceTracked } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";

const AuditLogTablePanel: React.FC = () => {
    const [auditLogState] = useAuditLogMaintenanceTracked();
    const gridRef: any = useRef(null);
    const { auditLogList, searchCriteria } = auditLogState;
    const auditLogVM = useAuditLogMaintenanceVM();
    const [currentColDefs, setCurrentColDefs] = useState<any[]>(INITIAL_CHARGE_AUDIT_LOG_COL_DEF);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(auditLogState.isSearchLoading || (!auditLogState.isSearchLoading &&
            auditLogList && auditLogList.length) ? false : true);
    }, [auditLogState.isSearchLoading, auditLogList]);

    useEffect(() => {
        const initialTable = async () => {
            if (searchCriteria.auditLogType) {
                switch (searchCriteria.auditLogType) {
                    case "Line Charge Related":
                        setCurrentColDefs(INITIAL_CHARGE_AUDIT_LOG_COL_DEF);
                        break;
                    case "Counter Charge Related":
                        setCurrentColDefs(INITIAL_CHARGE_AUDIT_LOG_COL_DEF);
                        break;
                    case "Waiver Related":
                        setCurrentColDefs(INITIAL_WAIVER_AUDIT_LOG_COL_DEF);
                        break;
                    case "Collection Related":
                        setCurrentColDefs(INITIAL_COLLECTION_AUDIT_LOG_COL_DEF);
                        break;
                    case "Maintenance Related":
                        setCurrentColDefs(INITIAL_COMPANY_AUDIT_LOG_COL_DEF);
                        break;
                }
            }
        }
        initialTable();

    }, [searchCriteria.auditLogType])

    const handleRowDoubleClick = useCallback(async (entity: AuditLogEntity) => {
        setIsLoading(true);
        await auditLogVM.onRowDoubleClick(entity).then(data => {
            setIsLoading(false);
        });
    }, [auditLogVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='audit-log-table'
                isNewColumnSetting={true}
                columns={currentColDefs}
                data={transferRowData(auditLogList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                rowSelection={"single"}
                showReloadIcon={false}
                isScrollHighlighted={true}
                onRowDoubleClick={(e: any, entity: AuditLogEntity) => handleRowDoubleClick(entity)}
                selectionMode={false}
                isRowHighligted={true}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [currentColDefs, auditLogList, handleRowDoubleClick, showOverlay])

    return <><TableWrapper>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(AuditLogTablePanel);
